import React from "react";

import logo from "../Assets/Logo.svg";

export const Profile = () => {
  return (
    <div className="container responsive-page-shell">
      <header className="header">
        <img className="logo-image" src={logo} alt="logo" />
        <div className="logo-text">
          <span className="C-logo">C</span>
          <span className="hezzle-logo">
            he<span className="Z-1">Z</span>
            <span className="Z-2">Z</span>le
          </span>
        </div>
      </header>
      <div className="gradient-line"></div>
      <div className="core-page-placeholder">Profile</div>
    </div>
  );
};
